import { styled } from 'next-yak'

export const ProjectCardTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  line-height: 23px;
  margin: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
